module.exports = __webpack_public_path__ + "img/taxaEntrega.8b179ffc.svg";